import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Field as Field$1 } from "@radix-ui/react-form";
import styles from "./form.module.css.js";
import classNames from "classnames";
const Field = forwardRef(
  function Field2({ children, ...props }, ref) {
    const classes = classNames(styles.field, props.className);
    return /* @__PURE__ */ jsx(Field$1, { ref, ...props, className: classes, children });
  }
);
export {
  Field
};
//# sourceMappingURL=Field.js.map
